var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,166.4c-8.5,0.1-16.9,1.5-25,4c3.7,6.6,5.7,14,5.8,21.6c0,24.7-20.1,44.8-44.8,44.8c-7.6-0.1-15-2-21.6-5.8 c-13.7,47.4,13.7,97,61.1,110.6c47.4,13.7,97-13.7,110.6-61.1c13.7-47.4-13.7-97-61.1-110.6C272.9,167.6,264.5,166.4,256,166.4z  M483.6,244.3C440.2,159.7,354.3,102.4,256,102.4S71.7,159.7,28.4,244.3c-3.7,7.3-3.7,16,0,23.4C71.8,352.3,157.7,409.6,256,409.6 s184.3-57.3,227.6-141.9C487.3,260.3,487.3,251.7,483.6,244.3z M256,371.2c-78.9,0-151.3-44-190.3-115.2 c39.1-71.2,111.4-115.2,190.3-115.2s151.3,44,190.3,115.2C407.3,327.2,334.9,371.2,256,371.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1517beb78b0432a936ff2b61383f21cc.svg";
export { ForwardRef as ReactComponent };